module.exports = __webpack_public_path__ + "img/chess.d902afcd.png";